import { AfterViewInit, Component, ElementRef, Renderer2, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements AfterViewInit {

 

  @ViewChildren('notFound', {read: ElementRef}) notFound: ElementRef

 constructor(private element: ElementRef, private renderer: Renderer2){}

   
   ngAfterViewInit(){
    setInterval(this.createStar,100);
    
  }

   createStar(){
    var right=Math.random()*500;
    var top=Math.random()*screen.height;
    var star=document.createElement("div");
      star.classList.add("star")
      this.renderer.appendChild(this.notFound , star);
      setInterval(runStar,10);
    star.style.top=top+"px";
  function runStar(){
    if(right>=screen.width){
      star.remove();
    }
    right+=3;
    star.style.right=right+"px";
  }
  } 
  
}
